import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'sl-footer-links',
  standalone: true,
  imports: [MatIconModule, NgFor],
  templateUrl: './footer-links.component.html',
})
export class FooterLinksComponent implements OnInit{

    @Input() data:any;


    ngOnInit(): void {


    }



}
